import Map from './Map.js'

export default class World {
    constructor() {
        this.map = new Map()
    }

    update() {
    }

}
